import type { IconData } from '@stacksjs/iconify-core'

export const travelCompass: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.25 8a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M6 5h6l-2 6H4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelCompass
